import React, { useEffect, useState } from 'react'
import { Dialog, DialogContent, Slide } from '@material-ui/core'
import DoneIcon from '@material-ui/icons/Done'

const Transition = React.forwardRef(function Transition (props, ref) {
  return <Slide direction='up' ref={ref} {...props} />
})

export default function PantallaConfirmacion (props) {
  const { close = null } = props
  const [open, setOpen] = useState(true)
  const [seconds, setSeconds] = useState(1)

  const handleClose = () => {
    setOpen(false)
  }

  useEffect(() => {
    const interval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1)
      }
      if (seconds === 0) {
        clearInterval(interval)
        if (close) { close() }
        handleClose()
        setSeconds(1)
      }
    }, 500)

    return () => {
      clearInterval(interval)
    }
  })

  return (
    <Dialog fullScreen open={open} TransitionComponent={Transition} className='pantalla-confirmacion'>
      <DialogContent style={{ backgroundColor: 'rgb(7 188 12 / 78%)' }} >
        <div className='mensaje-pantalla-confirmacion'>
          <DoneIcon style={{ color: '#ffffff', fontSize: '7rem', opacity: '0.9' }} />
        </div>
      </DialogContent>
    </Dialog>
  )
}
